import 'react/jsx-runtime';
import '@fluentui/react';
import '../context/context.esm.js';
import 'react';
import '@agoras/rest-client';
import { SuggestionTypes } from './Suggestions/types.esm.js';
import './Suggestions/SuggestionItem/LinkedAddIns.esm.js';
import './Suggestions/SuggestionItem/SuggestionItem.style.esm.js';
import './Suggestions/SuggestionTitle/SuggestionTitle.esm.js';

var SEARCH_HISTORY_KEY = 'msft-agoras-layout-search-history';
function getSearchHistory() {
    try {
        var prevHistory = window.localStorage.getItem(SEARCH_HISTORY_KEY);
        if (typeof prevHistory !== 'string') {
            return [];
        }
        return JSON.parse(prevHistory);
    } catch (e) {
        return [];
    }
}
function saveSearchHistory(term) {
    if (!term) {
        return;
    }
    var timestamp = Date.now();
    var searchHistory = getSearchHistory();
    var existingTerms = new Set(searchHistory.map(function(item) {
        return item.displayText;
    }));
    if (existingTerms.has(term)) {
        return;
    }
    var id = "".concat(SuggestionTypes.History, ":").concat(timestamp.toString(), ":").concat(term.toLocaleLowerCase());
    searchHistory.unshift({
        id: id,
        suggestionType: SuggestionTypes.History,
        displayText: term,
        timestamp: timestamp
    });
    window.localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(searchHistory.sort(function(a, b) {
        var _b_timestamp, _a_timestamp;
        return ((_b_timestamp = b.timestamp) !== null && _b_timestamp !== void 0 ? _b_timestamp : 0) - ((_a_timestamp = a.timestamp) !== null && _a_timestamp !== void 0 ? _a_timestamp : 0);
    }).slice(0, 10)));
}
function removeSearchHistory(itemToRemove) {
    var items = getSearchHistory();
    var filteredItems = items.filter(function(item) {
        return item.id !== itemToRemove.id;
    });
    window.localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(filteredItems));
}

export { SEARCH_HISTORY_KEY, getSearchHistory, removeSearchHistory, saveSearchHistory };
